// extracted by mini-css-extract-plugin
module.exports = {"desktopModalPaper":"UpdateExpiryModal_desktopModalPaper__ss2is","mobileModalPaper":"UpdateExpiryModal_mobileModalPaper__3mZye"};